// eslint-disable-next-line @typescript-eslint/no-explicit-any
function debounce(callback: (...args: any) => any, debounceTimeMs: number) {
  let timeout: number;

  return (...args: Parameters<typeof callback>) => {
    const deferred = () => {
      timeout = null;
      callback(...args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(deferred, debounceTimeMs) as unknown as number;
  };
}

export default debounce;
